import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps } from "@wordpress/block-editor";

export default function FormSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return;
}
